import React from 'react';

const Cuti = () => {
  return (
    <h1>Cuti</h1>
  );
};

export default Cuti;





